import { useRef, useEffect } from 'react';

const useCursor = () => {
  const cursorPos = useRef({ x: 0, y: 0 });
  useEffect(() => {
    const listenerArgs = [
      'mousemove',
      e => {
        cursorPos.current.x = e.clientX;
        cursorPos.current.y = e.clientY;
      },
    ];
    window.addEventListener(...listenerArgs);
    return () => window.removeEventListener(...listenerArgs);
  });

  return {
    isCursorOverElement: element => {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      let isInBound = true;
      if (cursorPos.current.y < rect.top || cursorPos.current.y > rect.bottom) isInBound = false;
      if (cursorPos.current.x < rect.left || cursorPos.current.x > rect.right) isInBound = false;
      return isInBound;
    },
  };
};

export default useCursor;
